module.exports = __webpack_public_path__ + "static/media/dfappgallery.28fa34f4.svg";